import Loading from 'components/Loading';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import { getSSOClients, deleteSSOClient } from '../../data/sso-clients';
import Pagination from 'react-js-pagination';

const ListSSOClients = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [clients, setClients] = useState<any[]>([]);
    const [count, setCount] = useState(0);
    const [activePage, setActivePage] = useState(1);

    const fetchClients = async (page = 1) => {
        setLoading(true);
        try {
            const resp = await getSSOClients(page);
            setClients(resp.data.results);
            setCount(resp.data.count);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchClients();
    }, []);

    const handlePageChange = (page: number) => {
        setActivePage(page);
        fetchClients(page);
    };

    const handleDelete = async (id: string, name: string) => {
        const confirm = await swal({
            title: 'Eliminar cliente SSO',
            text: `¿Eliminar "${name}"?`,
            icon: 'warning',
            buttons: ['Cancelar', 'Eliminar'],
            dangerMode: true,
        });
        if (!confirm) return;
        try {
            await deleteSSOClient(id);
            await swal('Afinidata', 'Cliente SSO eliminado', 'success');
            fetchClients(activePage);
        } catch (err) {
            swal('Afinidata', 'Error al eliminar', 'error');
        }
    };

    if (loading) return <Loading />;

    return (
        <div className="card">
            <div className="card-header">
                <div className="row">
                    <div className="col-md-6 col-sm-12">
                        <h4>Clientes SSO</h4>
                    </div>
                    <div className="col-md-6 col-sm-12 text-right">
                        <Link to="/admin/sso-clients/add" className="btn btn-primary">
                            <i className="fa fa-plus"></i> Nuevo cliente SSO
                        </Link>
                    </div>
                </div>
            </div>
            <div className="card-body">
                {clients.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table" width="100%">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Slug</th>
                                    <th>Issuer URL</th>
                                    <th>Secret</th>
                                    <th>Estado</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {clients.map(client => (
                                    <tr key={client.id}>
                                        <td>{client.name}</td>
                                        <td><code>{client.slug}</code></td>
                                        <td><small>{client.issuer_url}</small></td>
                                        <td><code>{client.client_secret_hint ? `***${client.client_secret_hint}` : '—'}</code></td>
                                        <td>
                                            {client.is_active
                                                ? <span className="badge badge-success">Activo</span>
                                                : <span className="badge badge-secondary">Inactivo</span>
                                            }
                                        </td>
                                        <td className="text-right">
                                            <Link to={`/admin/sso-clients/${client.id}/edit`} className="btn btn-warning btn-sm">
                                                <i className="fa fa-edit"></i>
                                            </Link>
                                            <button
                                                className="btn btn-danger btn-sm ml-2"
                                                onClick={() => handleDelete(client.id, client.name)}
                                            >
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={50}
                            totalItemsCount={count}
                            pageRangeDisplayed={10}
                            onChange={handlePageChange}
                            itemClass="page-item"
                            linkClass="page-link"
                            innerClass="pagination justify-content-center"
                        />
                    </div>
                ) : (
                    <div className="alert alert-info">No hay clientes SSO configurados</div>
                )}
            </div>
        </div>
    );
};

export default ListSSOClients;
